import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions } from 'vuex'
import AuthService from '../../services/auth/AuthService'

export default {

    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            hasError: false,
            identification: '',
            password: '',
            loading: false,
            isShowModal: false,
            check: false,
            closemodal: false,
            checkbox: false,

        }
    },

    methods: {
        ...mapActions('auth', ['loginApp']),
        // load() {
        //     if (this.check === true) {
        //         this.isShowModal = false
        //         localStorage.setItem('modal', this.isShowModal)
        //     }
        // },

        submit() {
            let { identification, password } = this;
            this.loading = true

            this.loginApp({ identification, password }).then((result) => {
                this.loading = false
                
                this.$router.go('/home');
                
            }).catch((error) => {
                this.loading = false
                if (error.statusCode == 404 || error.statusCode == 409) {
                    this.$buefy.toast.open({ message: this.$t('app.components.login.invalid-user-or-password'), type: 'is-danger' })
                }
            });

        },


    }
}